import React, { FC } from 'react';

type Props = {
    readonly salesTag: string;
};

const BundleBadge: FC<Props> = ({ salesTag }) => {
    return (
        <div className="badges bundle-badge">
            <div className="bd marked bgreen">{salesTag}</div>
        </div>
    );
};

export default BundleBadge;
